export const Authorizing = () => {
    return (
        <div className="modal is-active">
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="overlay_message_container">
                    <div className="is-loading-label">
                        Loading...
                    </div>
                    <progress className="progress is-small is-info" max="100"></progress>
                </div>
            </div>
        </div>
    );
}